const { origin } = window.location;

export const routes = {
  main: `${origin}/`,
  policyDetails: (id: string) => `${origin}/policy/${id}`,
  settings: (success?: boolean) =>
    `${origin}/settings${success ? "?success=true" : ""}`,
  editName: `${origin}/settings/name`,
  editMailingAddress: `${origin}/settings/address`,
  editPhoneNumber: `${origin}/settings/phone`,
  go: (route: string) => window.location.assign(route),
  documentDelivery: `${origin}/settings/document-delivery`,
  updatePaymentMethod: (policyNumber: string) =>
    `${origin}/settings/update-payment-method/${policyNumber}`,
};
